import React from 'react';
import classNames from 'classnames';
import { CmsPageContent } from 'src/shared/cms';

import { isWebView } from 'src/client/helpers';
import { Wrapper } from './styles';
import { useStaticPage } from './hooks/use-static-page';
import StaticPage from './static-page';
import { useNormalizedPath } from './hooks/use-normalized-path';

interface StaticPageWrapperProps {
    isGuest?: boolean;
    defaultCmsData?: CmsPageContent;
}

export const StaticPageWrapper: React.FC<StaticPageWrapperProps> = ({
    isGuest,
    defaultCmsData,
}) => {
    const { header, html, type, richText } = useStaticPage(
        useNormalizedPath(),
        defaultCmsData?.staticPage,
    );

    const isWebview = isWebView();

    return (
        <Wrapper
            className={classNames({
                'is-guest': isGuest,
                'is-webview': isWebview,
            })}
        >
            <StaticPage html={html} header={header} type={type} richText={richText} />
        </Wrapper>
    );
};

export default StaticPageWrapper;
